import React from 'react';

const PageHeader = ({ title }) => (
  <div style={{ marginBottom: '4px' }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
      <h2 style={{
        fontSize: 'clamp(1.8rem, 4vw, 2.6rem)',
        fontWeight: 800,
        color: '#facc15',
        textShadow: '0 0 24px rgba(250,204,21,0.45), 0 0 60px rgba(250,204,21,0.15)',
        letterSpacing: '-0.025em',
        lineHeight: 1,
        margin: 0,
        whiteSpace: 'nowrap',
      }}>
        {title}
      </h2>
      <div style={{
        flex: 1,
        height: '1px',
        background: 'linear-gradient(90deg, rgba(250,204,21,0.5) 0%, rgba(250,204,21,0.08) 60%, transparent 100%)',
      }} />
    </div>
    <div style={{
      marginTop: '7px',
      height: '2px',
      width: '36px',
      background: 'linear-gradient(90deg, #facc15, rgba(250,204,21,0.2))',
      borderRadius: '2px',
      boxShadow: '0 0 10px rgba(250,204,21,0.55)',
    }} />
  </div>
);

export default PageHeader;
